module.exports = __webpack_public_path__ + "static/media/American Society of Hematology Logo.03de60aa.jpeg";